


















































































































































































































































































































































































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import Bus from "@/JS/Bus";
import { setCookie, getCookie, delCookie } from "@/JS/cookie"; //使用getCookie方法
import httpApi from "@/API/Tenant/Weixin";
const draggable = require("vuedraggable"); //引入拖动排序插件
import formComponent from "./formComponent.vue";
import setFormComponent from "./setFormComponent.vue";
@Component({
  components: {
    formComponent,
    setFormComponent,
    draggable
  }
})
export default class extends Vue {
  @Prop() private propFormObj!: any; //修改表单数据
  @Prop() private propFormIndex!: any; //修改表单下标
  @Provide() activeName: string = "listForm"; //当前选中tab的name
  @Provide() currentSetTab: number = 0;
  @Provide() curSelectedModuleData: any = null;
  @Provide() timer: any = "";
  @Provide() headerTime: any = "";
  @Provide() title = "新建表单";
  @Provide() loading = false;
  @Provide() tenantID: any = 0;
  @Provide() sysTemplateTypeOptions: any = [];
  @Provide() currentTime: any =
    new Date().getFullYear() +
    "-" +
    (new Date().getMonth() + 1) +
    "-" +
    new Date().getDate() +
    " " +
    new Date().getHours() +
    ":" +
    new Date().getMinutes() +
    ":" +
    new Date().getSeconds();
  @Provide()
  moduleMenu: any = [];
  @Provide() styleList: any = [];
  @Provide() selectedModuleList: any = [];
  @Provide() mandate: any = [
    {
      value: 0,
      label: "不使用公众号发起授权"
    },
    {
      value: 1,
      label: "通过创畅公众号发起授权"
    },
    {
      value: 2,
      label: "通过自已公众号收集发起授权"
    }
  ];
  @Provide() tenants: any = [];
  @Provide() adminList: any = [];
  @Provide() pageInfo: any = {
    mtitle: "未命名表单",
    styleIndex: "0",
    bgColor: "#FFF",
    bgImg: null, //'http://img.crd.cn/upload/special/1574945279000keyseries/app/app_01.jpg',
    coverImg:
      "https://xds-10-1-1255528578.file.myqcloud.com//img/frm/templ/6/1.png",
    codeUrl:
      "https://h5.xiaodashi.com/activity/tempForm?id=6&carry=cdd3907f2565e4ff281f88e476d82074",
    topBottomPadding: 0,
    leftRightPadding: 0,
    fontSize: 14,
    fontColor: "#353535",
    formatType: "column",
    isSubmitTime: false,
    submitTime: "",
    isShouQuan: 0,
    isGetPersonal: 0,
    shouQuanTenants: "",
    mandateId: 0,
    maxTousu: 10,
    getTouSuAdmin: [],
    shareTitle: "",
    shareDesc: "",
    shareCoverImg: "https://img.crd.cn/module/2020-04-02/55.jpg",
    glActive: 0,
    lookNum: 0,
    totalWriteCount: 0,
    writeCount: 0,
    yesterdayWriteCount: 0,
    status: "收集中",
    statusInt: 2,
    createTime: this.currentTime,
    moduleList: this.selectedModuleList
  };
  @Provide() formatList: any = [
    {
      value: "column",
      label: "标题在上输入框在下"
    },
    {
      value: "row",
      label: "标题在左输入框在右侧"
    },
    {
      value: "none",
      label: "不显示标题"
    }
  ];
  @Provide() value: number = 0;
  //初始化
  async created() {
    this.tenantID = getCookie("TenantID");
    this.GetmoduleMenu();
    this.GetStyleList();
    this.GetSmartTypeList();
    if (this.tenantID == "0") {
      this.title = "新建模板表单";
    }
    let _this = this;
    _this.timer = setInterval(function() {
      _this.headerTime = //修改数据date
        new Date().getHours() +
        ":" +
        (new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes());
    }, 1000);
    if (this.propFormObj) {
      console.log(this.propFormObj);
      //this.propFormObj.moduleList=JSON.parse(this.propFormObj.moduleList);
      this.pageInfo = this.propFormObj;
      this.pageInfo.isGetPersonal = this.pageInfo.isGetPersonal + "";
      this.selectedModuleList = this.propFormObj.moduleList;
    }
    /*加载公众号列表 */
    var accountsList = JSON.parse(Utils.decrypt(localStorage.getItem('tencentsList') as any, ""));
    this.tenants = [];
    accountsList.forEach((element: any) => {
      if (
        element.TypeCode == "TypeCode_002" ||
        element.TypeCode == "TypeCode_007"
      ) {
        this.tenants.push({
          value: element.Aid + "",
          label: element.Name
        });
      }
    });
  }
  //查询模板分类列表
  async GetSmartTypeList() {
    let params: any = {
      Input: []
    };
   // console.log(params);
    //this.loading = true;
    this.sysTemplateTypeOptions = [{label:'未分类',value:''}];
    var res: any = await httpApi.GetSmartTypeList(params);
    //this.loading = false; //sysTemplateTypeOptions
   // console.log(res);
    if (res.ErrorCode == 0) {
     // this.sysTemplateTypeOptions = res.output[0].value;
       res.output[0].value.forEach((element:any) => {
        this.sysTemplateTypeOptions.push({value:element,label:element});
      });
    } else {
      this.$message.error("失败：" + res.ErrorMessage);
    }
  }
  //测试弹出框选择人
  async remoteMethod(query: any) {
    if (query) {
      let params: any = {
        Input: [
          {
            Name: "AppFansSelect",
            Value: {
              Aid: this.pageInfo.shouQuanTenants,
              NickName: query,
              OpenID: "",
              Sex: -1
            }
          }
        ]
      };
      console.log(params);

      this.loading = true;
      this.adminList = [];
      var res: any = await httpApi.SarchFansList(params);
      this.loading = false;
      if (res.ErrorCode == 0) {
        // this.optionFansList =;
        res.output[0].value.forEach((element: any) => {
          this.adminList.push({
            label: element.NickName,
            value: element.OpenID
          });
          //this.temOptionList.push({ label: element.ElementName, value: element.ElementCode })
        });
        this.$forceUpdate();
        //console.log(this.optionFansList);
      } else {
        this.$message.error("失败：" + res.ErrorMessage);
      }
    }
  }
  //加载风格数据
  async GetStyleList() {
    let params: any = {
      Input: []
    };
    // console.log(params);
    var res: any = await httpApi.GetSySmartFormStyleAsync(params);
    //console.log(res);
    if (res.ErrorCode == 0) {
      let result = res.output[0].value;
      this.styleList = [];
      result.forEach((el: any, index: number) => {
        el.sIcon = "crd-menu";
        el.styleIndex = index;
        this.styleList.push(el);
      });
    } else {
      this.$message.error("读取风格列表失败：" + res.ErrorMessage);
    }
  }
  //上传背景图片
  async UploadImage(param: any) {
    //console.log(param);
    let reader = new FileReader();
    let typeValue = "SmartFormImage";
    console.log(param);
    reader.readAsDataURL(param.file);
    //console.log(reader);
    reader.onload = async e => {
      if (e.target) {
        let obj: any = (e.target as any).result;
        let params: any = {
          Input: [
            {
              Name: "Type",
              value: typeValue
            },
            {
              Name: "FileName",
              value: param.file.name
            },
            {
              Name: "FileBase64",
              value: obj
            }
          ]
        };
        // console.log(params);
        var res: any = await httpApi.SmartFormUploadVue(params);
        //console.log(res);
        if (res.ErrorCode == 0) {
          let valueStr = res.output[0].value;
          if (valueStr) {
            //console.log(valueStr);
            this.pageInfo.bgImg = valueStr;
          }
        } else {
          this.$message.error("保存失败：" + res.ErrorMessage);
        }
      }
    };
  }
  //上传分享图片
  async UploadImageShare(param: any) {
    //console.log(param);
    let reader = new FileReader();
    let typeValue = "SmartFormImageShare";
    console.log(param);
    reader.readAsDataURL(param.file);
    //console.log(reader);
    reader.onload = async e => {
      if (e.target) {
        let obj: any = (e.target as any).result;
        let params: any = {
          Input: [
            {
              Name: "Type",
              value: typeValue
            },
            {
              Name: "FileName",
              value: param.file.name
            },
            {
              Name: "FileBase64",
              value: obj
            }
          ]
        };
        // console.log(params);
        var res: any = await httpApi.SmartFormUploadVue(params);
        //console.log(res);
        if (res.ErrorCode == 0) {
          let valueStr = res.output[0].value;
          if (valueStr) {
            //console.log(valueStr);
            this.pageInfo.shareCoverImg = valueStr;
          }
        } else {
          this.$message.error("保存失败：" + res.ErrorMessage);
        }
      }
    };
  }
  //上传网页
  async UploadHtml(param: any) {
    //console.log(param);
    let reader = new FileReader();
    let typeValue = "SmartFormHtml";
    console.log(param);
    reader.readAsDataURL(param.file);
    //console.log(reader);
    reader.onload = async e => {
      if (e.target) {
        let obj: any = (e.target as any).result;
        let params: any = {
          Input: [
            {
              Name: "Type",
              value: typeValue
            },
            {
              Name: "FileName",
              value: param.file.name
            },
            {
              Name: "FileBase64",
              value: obj
            }
          ]
        };
        // console.log(params);
        var res: any = await httpApi.SmartFormUploadVue(params);
        console.log(res);
        if (res.ErrorCode == 0) {
          let valueStr = res.output[0].value;
          if (valueStr) {
            console.log(valueStr);
            //this.pageInfo.shareCoverImg = valueStr;
          }
        } else {
          this.$message.error("保存失败：" + res.ErrorMessage);
        }
      }
    };
  }
  //加载定义控件
  async GetmoduleMenu() {
    let params: any = {
      Input: [
        {
          Name: "TenantID",
          Value: getCookie("TenantID")
        }
      ]
    };
    var res: any = await httpApi.GetListSmartFormInputType(params);
    if (res.ErrorCode == 0) {
      this.moduleMenu = res.output[0].value;
      console.log(this.moduleMenu);
    } else {
      this.$message.error("取列表失败：" + res.ErrorMessage);
    }
  }
  // createdForm() {
  //   this.$emit("createForm", "addForm");
  // }
  // 子组件传值给组件
  selectedModule(item: any) {
    // debugger
    const that: any = this;
    that.curSelectedModuleData = item;
  }
  // 点击列表某项
  clickSelectedModuleList(item: any, index: number) {
    // debugger
    const that: any = this;
    that.currentSetTab = 0;
    var listLength = that.selectedModuleList.length;
    for (var i = 0; i < listLength; i++) {
      if (that.selectedModuleList[i].isSelected) {
        that.selectedModuleList[i].isSelected = false;
      }
    }
    item.isSelected = true;
    that.curSelectedModuleData = item;
  }
  setBoxVisible(i: number) {
    var content: any = this;
    content.currentSetTab = i;
  }
  /**
   * 添加组件
   */
  addModuleFn(elObj: any) {
    var content = this;
    for (var item of content.selectedModuleList) {
      if (item.isSelected) {
        item.isSelected = false;
      }
    }
    elObj.isSelected = true;
    var obj = JSON.parse(JSON.stringify(elObj));
    content.selectedModuleList.push(obj);
    var len = parseInt(content.selectedModuleList.length) - 1;
    content.curSelectedModuleData = content.selectedModuleList[len];
  }
  /** 选择风格设置 */
  selectStyleFn(si: number) {
    this.pageInfo = this.styleList[si];
    this.adminList = JSON.parse(this.pageInfo.getTouSuAdmin);
  }
  /**
   * 一键设置所有表单的排版
   */
  setAllLayout(svalue: string) {
    var that = this;
    var l = that.selectedModuleList.length;
    if (l > 0) {
      for (var i = 0; i < l; i++) {
        that.selectedModuleList[i].style = svalue;
      }
    }
  }
  /**
   * 移除当前组件
   */
  removeModule(clickIndex: any) {
    var content = this;
    this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(() => {
        content.selectedModuleList.splice(clickIndex, 1);
        this.$message({
          type: "success",
          message: "删除成功!"
        });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
  }
  /**
   * 清除所有组件
   */
  clearAll() {
    this.selectedModuleList = [];
    this.curSelectedModuleData = "";
  }
  /**
   * 保存当前模板设置
   */
  saveModuleFn() {
    var that = this;
    if (!that.pageInfo.mtitle) {
      this.$message.error("请设置表单名称！");
    } else {
      that.pageInfo.moduleList = that.selectedModuleList;
      this.$emit("formData", {
        pagename: "listForm",
        pageindex: that.propFormIndex,
        pageinfo: that.pageInfo
      });
    }
  }
  resetModuleFn() {
    this.$emit("formData", {
      pagename: "listForm",
      pageindex: null,
      pageinfo: null
    });
  }
}
